module.exports = require("core-js/modules/es.array.reduce.js");